import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
	selector: 'formly-template',
	template: `
		<label *ngIf="to.label">{{ to.label }}</label>
		<div [innerHtml]="to.template"></div>
	`,
	standalone: true,
	imports: [NgIf],
})
export class FormlyTemplateComponent extends FieldType {}
